<template src="./html/Places.html"></template>

<script>
	import swal from 'sweetalert2'
	import Create from './../views/Create.vue'
	import Edit from './../views/Edit.vue'

	export default {
		props: ['user', 'isAuth', 'places', 'resource'],
		components: {
			'create': Create,
			'edit': Edit,
		},
		data () {
			return {
				modal: {
					selector: 'modal-places'
				}
			}
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.$emit('reload')
			},
			destroy(item) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get(that.resource + '/places/' + item.id)
							.then(response => {
								that.$emit('reload')
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/places/layout/Places.vue